<div class="toggle">
  <input tuiSwitch type="checkbox" [size]="size" [(ngModel)]="value" [disabled]="disabled" [readOnly]="readOnly" />
</div>
